let host = null;
let pendingNotices = [];
let pendingRequests = [];
let sequence = 0;

const nextId = (prefix) => `${prefix}-${Date.now()}-${++sequence}`;
const toText = (value) => {
  if (value === null || value === undefined) return "";
  if (value instanceof Error) return value.message || String(value);
  return String(value);
};

const inferTone = (message) => {
  const text = toText(message).trim().toLowerCase();

  if (
    text.includes("✅") ||
    text.includes("успеш") ||
    text.includes("добавлен") ||
    text.includes("сохран") ||
    text.includes("отправлен") ||
    text.includes("обновл") ||
    text.includes("скопирован") ||
    text.includes("готово")
  ) return "success";

  if (
    text.includes("ошиб") ||
    text.includes("не удалось") ||
    text.includes("запрещ") ||
    text.includes("нельзя") ||
    text.includes("failed") ||
    text.includes("error") ||
    text.includes("denied")
  ) return "error";

  if (
    text.includes("выберите") ||
    text.includes("укажите") ||
    text.includes("требуется") ||
    text.includes("только для") ||
    text.includes("войдите") ||
    text.includes("нужно войти")
  ) return "warning";

  return "info";
};

export const registerUiFeedbackHost = (nextHost) => {
  host = nextHost;
  pendingNotices.splice(0).forEach((notice) => host.notify(notice));
  pendingRequests.splice(0).forEach((request) => host.request(request));

  return () => {
    if (host === nextHost) host = null;
  };
};

export const showNotice = (message, options = {}) => {
  const notice = {
    id: options.id || nextId("notice"),
    message: toText(message).trim(),
    title: toText(options.title).trim(),
    tone: options.tone || inferTone(message),
    duration: Number.isFinite(Number(options.duration))
      ? Math.max(0, Number(options.duration))
      : undefined,
  };

  if (!notice.message) return "";
  if (host) host.notify(notice);
  else pendingNotices = [...pendingNotices, notice].slice(-20);
  return notice.id;
};

const requestAction = (kind, options) =>
  new Promise((resolve) => {
    const data = typeof options === "string"
      ? { message: options }
      : { ...(options || {}) };

    const request = {
      id: data.id || nextId(kind),
      kind,
      title: toText(data.title).trim(),
      message: toText(data.message).trim(),
      variant: data.variant || "default",
      confirmLabel: toText(data.confirmLabel).trim(),
      cancelLabel: toText(data.cancelLabel).trim(),
      placeholder: toText(data.placeholder).trim(),
      defaultValue: toText(data.defaultValue),
      inputType: data.inputType || "text",
      required: data.required === true,
      resolve,
    };

    if (host) host.request(request);
    else pendingRequests.push(request);
  });

export const confirmAction = (options) => requestAction("confirm", options);
export const promptAction = (options) => requestAction("prompt", options);

const BRIDGE_KEY = "__mapapetNativeAlertBridge__";

export const ensureNativeAlertBridge = () => {
  if (typeof window === "undefined" || window[BRIDGE_KEY]) return;
  window[BRIDGE_KEY] = { originalAlert: window.alert?.bind(window) };
  window.alert = (message) => {
    showNotice(message);
  };
};

ensureNativeAlertBridge();
